import React from 'react';
import ComingSoon from '../../components/ComingSoon/ComingSoon';

const QuienesSomos = () => {
  return (
    <ComingSoon
      title="Quiénes Somos"
      subtitle="Conoce al equipo detrás del programa"
      icon="👥"
    />
  );
};

export default QuienesSomos;
